import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { TwitterLoginIcon } from 'icons/login/TwitterLoginIcon';
import { ShareIcon } from 'icons/ShareIcon';
import { usePathname } from 'next/navigation';
import { ExternalLink } from 'ui-components/common/ExternalLink';
import { IconButton } from 'ui-components/common/IconButton';
import { useShare } from 'ui-hooks/useShare';
import { configure } from 'utils/configure';

interface EventShareProps {
  eventTitle: string;
}

export const EventShare = ({ eventTitle }: EventShareProps) => {
  const pathname = usePathname() ?? '';
  const handleShare = useShare();
  const thisUrl = `${configure.serviceUrl}${pathname}`;

  return (
    <StylesContainer>
      <StylesTitle>이벤트 공유하기!</StylesTitle>
      <StylesIcons>
        <StylesIcon color={Color.Twitter}>
          <StyledExternalLink
            href={`https://twitter.com/share?text=${encodeURIComponent(eventTitle)}&url=${encodeURIComponent(
              thisUrl,
            )}`}>
            <TwitterLoginIcon color={Color.White} className="size-[24px]" />
          </StyledExternalLink>
        </StylesIcon>
        <StylesIcon color={Color.Gray400}>
          <IconButton onClick={() => handleShare({ title: eventTitle, text: eventTitle, url: thisUrl })}>
            <ShareIcon color={Color.White} />
          </IconButton>
        </StylesIcon>
      </StylesIcons>
    </StylesContainer>
  );
};

const StylesContainer = styled.section`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StylesTitle = styled.p`
  font-weight: ${FontWeight.Bold};
  ${Typography.Medium}
`;

const StylesIcon = styled.div(
  ({ color }: { color: string }) => css`
    background-color: ${color};
    width: 56px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
  `,
);

const StyledExternalLink = styled(ExternalLink)`
  width: 24px;
  height: 24px;
`;

const StylesIcons = styled.div`
  display: flex;
  margin-top: 16px;

  ${StylesIcon} + ${StylesIcon} {
    margin-left: 24px;
  }
`;
